
export enum ModeloGrafico {
  MelhoresAvaliacoes = 1,
  VolumetriaAvaliacoes = 2,
  MetaRealizadoPrevisto = 3,
  VolumetriaTipoCheckup = 4
}